import React from 'react';
import './Home.css';
import { FaUsers, FaCheckCircle, FaLeaf, FaSolarPanel } from 'react-icons/fa';

const Home = () => {
  return (
    <div>
      <div className="solar">
        <img src="/Home.jpg" alt="Solar Panel" />
        <div className="overlay1">
          <h1 className="overlay-text1">Home</h1>
        </div>
      </div>
      <div className="home">
        <h1>At Ecoclean Solar Solutions, we offer one-time and scheduled solar panel cleaning services for both residential and commercial customers.</h1>
        <h2>Why choose Ecoclean Solar Solutions?</h2>
      </div>
      <div className="services">
        <div className="service-box">
          <FaUsers size={50} />
          <h2>Experienced Team</h2>
          <p>We have a fleet of Highly Trained and Experienced individuals who ensure that the best value is delivered.</p>
        </div>
        <div className="service-box">
          <FaCheckCircle size={50} />
          <h2>Top-End Products</h2>
          <p>After countless hours of testing and QA, we ensure that the best quality cleaning products are used.</p>
        </div>
        <div className="service-box">
          <FaLeaf size={50} />
          <h2>Solar Friendly Cleaning</h2>
          <p>Our products are 100% Solar Panel & Environment Friendly through rigorous testing and QA processes.</p>
        </div>
        <div className="service-box">
          <FaSolarPanel size={50} />
          <h2>Energy Generation</h2>
          <p>After our detailed research, we are the only company that proves an increase in your power generation of up to 30%.</p>
        </div>
      </div>
    </div>
  );
};

export default Home;
